import styled from "styled-components";

import { ONBOARDING_AGENT_PANEL_RESIZE_TRANSITION_MS, PANEL_TRANSITION_MS, PANEL_Z_INDEX } from "./constants";
import { getPanelSlideOffsetY } from "./helpers/OnboardingAgentPosition.helpers";
import type { OnboardingAgentPlacement } from "./OnboardingAgent.types";

type AnimatedPanelMountProps = {
    readonly $x: number;
    readonly $y: number;
    readonly $shouldAnimatePosition: boolean;
    readonly $placement: OnboardingAgentPlacement;
};

const PANEL_ENTER_SLIDE_PX = 10;
const PANEL_EXIT_SLIDE_PX = 8;

/** Grows the panel out of the trigger's corner, whichever side the panel ended up opening to. */
const getTransformOrigin = ({ vertical, horizontal }: OnboardingAgentPlacement): string =>
    `${vertical === "above" ? "bottom" : "top"} ${horizontal}`;

const getPanelMotionTransform = (placement: OnboardingAgentPlacement, distance: number, scale: number): string =>
    `translate3d(0, ${getPanelSlideOffsetY(placement.vertical, distance)}px, 0) scale(${scale})`;

export const AnimatedPanelMount = styled.div<AnimatedPanelMountProps>`
    position: fixed;
    left: ${({ $x }) => $x}px;
    top: ${({ $y }) => $y}px;
    z-index: ${PANEL_Z_INDEX};
    transform: translate3d(0, 0, 0);
    transform-origin: ${({ $placement }) => getTransformOrigin($placement)};
    ${({ $shouldAnimatePosition }) =>
        $shouldAnimatePosition
            ? `
                transition:
                    left ${ONBOARDING_AGENT_PANEL_RESIZE_TRANSITION_MS}ms cubic-bezier(0.22, 1, 0.36, 1),
                    top ${ONBOARDING_AGENT_PANEL_RESIZE_TRANSITION_MS}ms cubic-bezier(0.22, 1, 0.36, 1);
            `
            : ""}

    &.onboarding-agent-panel-enter {
        opacity: 0;
        transform: ${({ $placement }) => getPanelMotionTransform($placement, PANEL_ENTER_SLIDE_PX, 0.97)};
    }
    &.onboarding-agent-panel-enter-active {
        opacity: 1;
        transform: translate3d(0, 0, 0) scale(1);
        transition:
            opacity ${PANEL_TRANSITION_MS}ms cubic-bezier(0.22, 1, 0.36, 1),
            transform ${PANEL_TRANSITION_MS}ms cubic-bezier(0.22, 1, 0.36, 1);
    }
    &.onboarding-agent-panel-exit {
        opacity: 1;
        transform: translate3d(0, 0, 0) scale(1);
    }
    &.onboarding-agent-panel-exit-active {
        opacity: 0;
        transform: ${({ $placement }) => getPanelMotionTransform($placement, PANEL_EXIT_SLIDE_PX, 0.98)};
        transition:
            opacity ${PANEL_TRANSITION_MS}ms ease-in,
            transform ${PANEL_TRANSITION_MS}ms ease-in;
    }
`;
